export default __webpack_public_path__ + "static/media/mobileshopifyview.7daa2ab5.png";